import { useState, useEffect, useCallback } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Gift, X, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const ExitIntentPopup = () => {
  const { language } = useLanguage();
  const [show, setShow] = useState(false);

  const t = {
    it: { title: 'Aspetta! Non andartene ancora...', subtitle: 'Scopri cosa possiamo fare per te', cta1: 'Valutazione Gratuita', cta2: 'Scopri Offerta -15%', or: 'oppure', close: 'No grazie' },
    en: { title: "Wait! Don't leave yet...", subtitle: 'Discover what we can do for you', cta1: 'Free Evaluation', cta2: 'Discover -15% Offer', or: 'or', close: 'No thanks' },
    es: { title: '¡Espera! No te vayas aún...', subtitle: 'Descubre lo que podemos hacer por ti', cta1: 'Evaluación Gratuita', cta2: 'Descubre Oferta -15%', or: 'o', close: 'No gracias' },
    pt: { title: 'Espere! Não vá ainda...', subtitle: 'Descubra o que podemos fazer por você', cta1: 'Avaliação Gratuita', cta2: 'Descubra Oferta -15%', or: 'ou', close: 'Não obrigado' },
  };
  const txt = t[language] || t.it;

  const handleMouseLeave = useCallback((e) => {
    if (e.clientY <= 5 && !sessionStorage.getItem('exit_popup_shown')) {
      setShow(true);
      sessionStorage.setItem('exit_popup_shown', '1');
    }
  }, []);

  useEffect(() => {
    if (sessionStorage.getItem('exit_popup_shown')) return;
    document.addEventListener('mouseleave', handleMouseLeave);
    return () => document.removeEventListener('mouseleave', handleMouseLeave);
  }, [handleMouseLeave]);

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4" data-testid="exit-intent-popup">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={() => setShow(false)} />

      {/* Modal */}
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden animate-in zoom-in-95 duration-300">
        {/* Close */}
        <button onClick={() => setShow(false)} className="absolute top-3 right-3 p-1.5 rounded-full hover:bg-gray-100 transition z-10" data-testid="exit-popup-close">
          <X className="w-5 h-5 text-gray-400" />
        </button>

        {/* Header */}
        <div className="bg-gradient-to-r from-blue-600 to-blue-700 px-6 py-8 text-center text-white">
          <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
            <Gift className="w-8 h-8" />
          </div>
          <h2 className="text-2xl font-bold mb-2" style={{ fontFamily: "'Cormorant Garamond', serif" }}>{txt.title}</h2>
          <p className="text-blue-100 text-sm">{txt.subtitle}</p>
        </div>

        {/* CTAs */}
        <div className="p-6 space-y-3">
          <Link
            to="/free-evaluation"
            onClick={() => setShow(false)}
            className="w-full flex items-center justify-center gap-2 px-6 py-3.5 bg-green-600 text-white font-semibold rounded-xl hover:bg-green-700 transition"
            data-testid="exit-popup-free-eval"
          >
            <Gift className="w-5 h-5" />
            {txt.cta1}
            <ArrowRight className="w-4 h-4" />
          </Link>

          <div className="text-center text-xs text-gray-400 uppercase tracking-wider">{txt.or}</div>

          <Link
            to="/spring-offer"
            onClick={() => setShow(false)}
            className="w-full flex items-center justify-center gap-2 px-6 py-3.5 bg-rose-600 text-white font-semibold rounded-xl hover:bg-rose-700 transition"
            data-testid="exit-popup-promo"
          >
            {txt.cta2}
            <ArrowRight className="w-4 h-4" />
          </Link>

          <button
            onClick={() => setShow(false)}
            className="w-full text-center text-sm text-gray-400 hover:text-gray-600 transition pt-2"
          >
            {txt.close}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExitIntentPopup;
